import styled, { keyframes } from "styled-components";
import { NavLink } from "react-router-dom";
import { HiOutlineDotsCircleHorizontal } from 'react-icons/hi'
import CalendarTodayRoundedIcon from '@material-ui/icons/CalendarTodayRounded';
import PersonIcon from '@material-ui/icons/Person';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';

const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-200px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
`;

export const Cointainer = styled.div`
  box-sizing: border-box;
  width: 100px;
  background-color: #ffffff;
  border-radius: 16px;
  position: fixed;
  z-index: 100;
  top: 15px;
  left: 15px;
  bottom: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  animation: ${fadeIn} 0.5s ease 0s;
  @media(max-width:990px){
    top: 63px;
    left: 0;
    bottom: 0;
    border-radius: 0;
  }
`;

export const CustomNavLink = styled(NavLink)`
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-shrink: 0;
  color: inherit;
  text-decoration: none;
`;

export const CustomNavLink1 = styled.div`
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-shrink: 0;
  cursor: pointer;
`;

export const CPersonIcon = styled(PersonIcon)`
  color:white;
  &:hover{
    color:grey;
  }
`
export const CPersonOutlineIcon = styled(PersonOutlineIcon)`
  color:white;
`
export const CHiOutlineDotsCircleHorizontal = styled(HiOutlineDotsCircleHorizontal)`
  color:white;
`
export const CBiCalendar = styled(CalendarTodayRoundedIcon)`
  color:white;
  &:hover{
    color:grey;
  }
`
